import type { NavItem } from '@nuxt/content'

export const useFetchLandingSeatsLinks = () => {
  const fetchLandingSeatsLink = async () => {
    const getLanguagesToFetch = useGetLanguagesToFetch()
    const languagesToFetch = getLanguagesToFetch()
    const lang = languagesToFetch.shift() as string
    const navigationItems = await fetchContentNavigation(queryLocalizedContent(`camper-type`, lang))
    const extractPaths = (data: NavItem[]) => {
      const result: {
        name: string
        nxt_url: string
      }[] = []

      const recursiveExtract = (items: NavItem[]) => {
        items.forEach((item) => {
          if (item.children) {
            recursiveExtract(item.children)
          }
          else {
            result.push({ name: item.title, nxt_url: item._path })
          }
        })
      }

      recursiveExtract(data)
      return result
    }
    return extractPaths(navigationItems)
  }

  return { fetchLandingSeatsLink }
}
